import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const MemberTypeList = Loadable(
  lazy(() => import("features/memberType/components/List"))
);
const MemberTypePage = Loadable(
  lazy(() => import("features/memberType/components/Page"))
);

const routes = {
  path: "memberType",
  children: [
    { path: "", element: <MemberTypeList /> },
    { path: "add", element: <MemberTypePage /> },
    { path: "edit/:memberTypeID?", element: <MemberTypePage /> },
  ],
};

export default routes;
